import React from 'react';

import * as S from './styles';

const Gallery08: React.FC = () => {
  return (
    <S.Container>
      <S.Wrapper>
        <S.Photo1
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="200ms"
        />
        <S.Caption className="mobile">
          <p>
            Detalhe de bunda masculina com jockstrap no desfile de verão 2023 de
            Thom Browne. Foto: Getty Images.
          </p>
        </S.Caption>
        <S.Photo2
          className="wow animate__animated animate__fadeIn"
          data-wow-duration="1s"
          data-wow-delay="400ms"
        />
      </S.Wrapper>
      <S.Caption className="mobile">
        <p>
          Desenho de Tom of Finland, de 1963. Foto: reprodução do livro “Tom of
          Finland – Bikers II”
        </p>
      </S.Caption>
      <S.Caption className="desktop">
        <p>
          À esq., detalhe de bunda masculina com roupa íntima erótica no desfile
          de verão 2023 de Thom Browne (Getty Images); à dir., desenho de Tom of
          Finland, de 1963 (reprodução do livro “Tom of Finland – Bikers II”).
        </p>
      </S.Caption>
    </S.Container>
  );
};

export default Gallery08;
